import React from 'react'

import { Button, ButtonProps } from 'react-admin'

import IconContentAdd from '@mui/icons-material/Add'

import { CreateModal, CreateModalProps } from './CreateModal'

interface CreateButtonProps extends ButtonProps {
  label?: string
  icon?: React.ReactElement

  button?: React.ReactElement

  modalTitle?: string

  onSuccess: CreateModalProps['onSuccess']
  onFailure: CreateModalProps['onFailure']
  query: CreateModalProps['query']
}

export const CreateButton: React.FC<CreateButtonProps> = (props) => {
  const {
    label = 'Create',
    icon = <IconContentAdd />,
    modalTitle,
    button,
    onSuccess,
    onFailure,
    query,
    ...restProps
  } = props

  const [showDialog, setShowDialog] = React.useState(false)

  const doClick = () => {
    setShowDialog(true)
  }

  return (
    <>
      {button ? (
        React.cloneElement(button, { onClick: doClick })
      ) : (
        <Button onClick={doClick} label={label} {...restProps}>
          {icon}
        </Button>
      )}

      <CreateModal
        title={modalTitle}
        open={showDialog}
        setOpen={setShowDialog}
        onSuccess={onSuccess}
        onFailure={onFailure}
        query={query}
      >
        {props.children}
      </CreateModal>
    </>
  )
}
